// extracted by mini-css-extract-plugin
module.exports = {"banner":"PaymentReminderBanner_banner__M_2qf","text":"PaymentReminderBanner_text__zMaYv"};